export default "__VITE_ASSET__CRscd1CY__"